<mat-icon class="icon-renderer__icon" [style.color]="color" [title]="label">
  {{ icon }}
</mat-icon>
